import { selector } from 'recoil';
import { userState } from '..';

export const userDisplayState = selector({
	key: 'userDisplayState',
	get: ({ get }) => {
		const user = get(userState);
		let initials = null;
		let username = user.username;
		if (user.isLogged) {
			// initials
			initials = user.username.split('.').map((str) => str[0].toUpperCase());

			initials.slice(0, 2).join('');

			// username
			if (user.name || user.surname) {
				username = `${user.name} ${user.surname}`;
			}
		}
		return {
			initials,
			username,
		};
	},
});
